<template>
<div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
    <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
    <el-breadcrumb-item>店铺审核</el-breadcrumb-item>
    </el-breadcrumb>
    <el-table :data="shopList.slice((currentPage-1) * pageSize,currentPage * pageSize)" stripe border style="width: 100%">
    <el-table-column prop="id" label="店铺id" align="center" />
    <el-table-column prop="shopName" label="店铺名" align="center" />
    <el-table-column prop="shopDesc" label="店铺描述" align="center" />
    <el-table-column prop="shopLevel" label="店铺资质" align="center" />
    <el-table-column prop="createTime" label="添加时间" align="center" />
    <el-table-column prop="enableStatus" label="店铺状态" align="center" />
    <el-table-column prop="phone" label="联系电话" align="center" />
    <el-table-column prop="shopStatus" label="审核状态" align="center">
        <template scope="scope">
        <el-button
            v-if="scope.row.status == '1'"
            type="success"
            size="mini"
            >通过</el-button
        >
        <el-button v-if="scope.row.status == '0'" type="info" size="mini"
            >拒绝</el-button
        >
        </template>
    </el-table-column>
        <el-table-column label="操作" width="200px" align="center">
        <!-- eslint-disable-next-line -->
        <template slot-scope="scope">
        <!--<el-button type="primary" @click="editCategoriesList">编辑</el-button>-->
        <el-button type="danger" @click="deleteCategories(scope.row)">删除</el-button>
        </template>
        </el-table-column>
    </el-table>
    <!--分页器-->
    <el-pagination
    background
    layout="prev,pager,next"
    :total="shopList.length"
    :current-page="currentPage"
    :page-size="pageSize"
    style="text-align: center;margin-top: 10px"
    @size-change="handleSizeChange"
    @current-change="handleCurrentPage"
    >
    </el-pagination>
</div>
</template>

<script>
import request from '../http/manage'
// import goods from '../../assets/json/categoriesList'
export default {
data () {
    return {
      /* 店铺列表数据 */
    shopList: [],
      currentPage: 1, // 初始页
      pageSize: 6, //    每页的数据
    shopNameList: [],
      shopId: '' // 店铺名对应id
    }
},
methods: {
    handleSizeChange (size) { // pageSize改变时触发
    this.pagesize = size
      // console.log('handleSizeChange')
    },
    handleCurrentPage (currentPage) { // 当前页面改变时触发
      // console.log(currentPage)
    this.currentPage = currentPage
      // console.log('handleCurrentPage')
    },
    async getShopIdList () { // 获取店铺列表
    const getShopNameData = {
        pageNum: 1,
        pageSize: 50,
        userName: window.sessionStorage.getItem('username')
    }
    const res = await request.getShopNameList(getShopNameData)
    this.shopNameList = res.data.data.content
    },
    async getTableList () {
      // eslint-disable-next-line no-unused-vars
      // const { data: res } = await this.$http.get('orders', {})
    let isEmpty = false// 是否取完
      while (!isEmpty) { // 取到的数据不为空 循环
        const resData = await request.getShopList({
        pageNum: 1,
        pageSize: 50
        })
        // console.log(resData.data)
        if (resData.data.data.length === 0) { // 若取到的数据为空
        isEmpty = true
        } else {
        this.tableData = this.tableData.concat(resData.data.data)
        }
    }
    },
    deleteShop (row) { // 删除指定id商品
    this.$confirm('此操作将永久删除该店铺信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
    }).then(() => {
        const id = row.id
        request.deleteShopId(id) // 删除请求
        // location.reload()// 刷新页面显示最新状态
        this.reload() // 局部刷新这里
        this.$message({
        type: 'success',
        message: '删除成功!'
        })
    }).catch(() => {
        this.$message({
        type: 'info',
        message: '已取消删除'
        })
    })
    },
    created () {
      this.getTableList() // jy 组件创建获取店铺名列表
    }
}
}
</script>
